import Vue from 'vue';
import VueTextEditor from '@telexpress/vue-text-editor';

Vue.use(VueTextEditor);
